import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    noPermissionMessage: false,
    notification: [],
    totalNotification: 0,
}

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setNotification: (state, action) => {
            state.totalNotification = action.payload.totalNotification
        },
        setNoPermission: (state, action) => {
            state.noPermissionMessage = action.payload;
        },
    },
})

export const { setNotification, setNoPermission } = commonSlice.actions

export default commonSlice.reducer